// ANGULAR DEPENDANCY
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// EXTERNAL DEPENDANCY
import { Observable } from 'rxjs';

// SERVICES
import { ApiConfigService } from '../../../core/services/api-config/api-config.service';
import { BaseService } from '../../../core/services/base/base.service';
import { TokenStorageService } from '../../../core/services/token-storage/token-storage.service';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';
import { ApiResponse } from '../../../../models/common/api/api-response.interface';

// COMMON UTILS
import { APIUtil } from '../../../../core/utils/api-util';

// CONSTANTS
import { AUTH_API_URL } from '../../../../constants/api/auth';

/**
 * This service is for auth api calls
 * For handle auth api calls
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially created auth service
 */
@Injectable()
export class AuthService extends BaseService {

  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService) {
    super(httpClient, tokenStorage);
  }

  /**
   * Auth common master api
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public authCommon(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['type'];
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${AUTH_API_URL[payload.data.type]}`, replaceParams, payload);

    return this.post(url, payload.data.data);
  }

  /**
   * Post login for user
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public login(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${AUTH_API_URL.LOGIN}`;
    return this.post(url, payload);
  }

  /**
  * Post logout for user
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public logout(payload: ApiPayload): Observable<ApiResponse> {
    const url = this.apiConfig.getApiUrl() + AUTH_API_URL.LOGOUT;
    return this.post(url, payload);
  }

  /**
   * Post Sign up method for user
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public signUp(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${AUTH_API_URL.SIGNUP}`;
    return this.post(url, payload);
  }

  /**
* Post forget password for user
* @param payload : Api common payload object
* @returns Observable<ApiResponse>
*/
  public forgotPassword(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${AUTH_API_URL.FORGOT_PASSWORD}`;
    return this.post(url, payload);
  }

  /**
* Post reset password token for user
* @param token : token for query param object
* @returns Observable<ApiResponse>
*/
  public checkResetPasswordToken(payload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${AUTH_API_URL.RESET_PASSWORD_TOKEN}?token=${payload.token}`;

    return this.post(url, null);
  }

  /**
* Post reset password for user
* @param payload : Api common payload object
* @returns Observable<ApiResponse>
*/
  public resetPassword(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${AUTH_API_URL.RESET_PASSWORD}`;

    return this.post(url, payload);
  }


  /**
	 * Used To Load the permission to reset password
	 * @param payload : Api common payload object
	 * @returns Observable<ApiResponse>
	 */
  public getPermission(payload: ApiPayload): Observable<ApiResponse> {
    const url =   `${this.apiConfig.getApiUrl()}${AUTH_API_URL.ACCESS_MODULES}`;

    return this.get(url);
  }

}

